<!-- 关于我们 -->
<template>
  <div class="aboutUs">
    <headerImg
      headerImgText
      :imgSrc="require('../../assets/aboutUs/aboutUsTop.jpg')"
    ></headerImg>
    <div>
      <img
        class="Introduction-img"
        src="../../assets/aboutUs/about.png"
        alt
      />
    </div>
    <div class="carouselFather">
      <div class="carouselHeader">荣誉资质</div>
      <el-carousel
        :interval="3000"
        type="card"
        height="300px"
      >
        <el-carousel-item
          v-for="(item,index) in carouselList"
          :key="index"
        >
          <el-card class="box-card">
            <div class="carouselBorder">
              <img
                class="carouselImg"
                :src="item.imgSrc"
                alt=""
                srcset=""
              >
            </div>

          </el-card>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import headerImg from "../../components/headerImg";
export default {
  data() {
    return {
      carouselList: [
        {
          imgSrc: require("../../assets/aboutUs/honor1.png"),
        },
        {
          imgSrc: require("../../assets/aboutUs/honor2.png"),
        },
        {
          imgSrc: require("../../assets/aboutUs/honor3.png"),
        },
        {
          imgSrc: require("../../assets/aboutUs/honor4.png"),
        },
        {
          imgSrc: require("../../assets/aboutUs/honor5.png"),
        },
        {
          imgSrc: require("../../assets/aboutUs/honor6.png"),
        },
        {
          imgSrc: require("../../assets/aboutUs/honor7.png"),
        },
        {
          imgSrc: require("../../assets/aboutUs/honor8.png"),
        },
        {
          imgSrc: require("../../assets/aboutUs/honor9.png"),
        },
      ],
    };
  },

  components: {
    headerImg,
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  methods: {},
};
</script>
<style scoped>
.aboutUs {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Introduction-img {
  width: 100%;
}
.carouselFather {
  width: 80%;
  margin: 0;
  padding: 0;
}
.carouselHeader {
  width: 100%;
  text-align: center;
  font-size: 24px;
  padding: 20px;
}
.carouselImg {
}
.carouselBorder {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>